<template>
  <ContentWrap title="日历价格管理">
    <el-alert class="mb-16px" type="info" :closable="false" title="价格与库存可在“日历量价合并”页面统一维护，本页面继续保留。" />
    <!-- 搜索工作栏 -->
    <el-form :model="queryParams" ref="queryFormRef" :inline="true" label-width="68px" class="-mb-15px nowrap-form" style="display: flex; flex-wrap: nowrap; align-items: center;">
      <el-form-item label="店铺" prop="shopId">
        <el-select
          v-model="queryParams.shopId"
          placeholder="请选择店铺"
          clearable
          class="!w-120px"
        >
          <el-option
            v-for="shop in shopList"
            :key="shop.id"
            :label="shop.name"
            :value="shop.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="房型" prop="spuId">
        <el-select
          v-model="queryParams.spuId"
          placeholder="请选择房型"
          clearable
          class="!w-120px"
        >
          <el-option
            v-for="spu in spuList"
            :key="spu.id"
            :label="spu.name"
            :value="spu.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="变体" prop="skuId">
        <el-select
          v-model="queryParams.skuId"
          placeholder="请选择变体"
          clearable
          class="!w-120px"
        >
          <el-option
            v-for="sku in skuList"
            :key="sku.id"
            :label="sku.name"
            :value="sku.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="日期范围" prop="dateRange">
        <el-date-picker
          v-model="queryParams.dateRange"
          type="daterange"
          value-format="YYYY-MM-DD"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          class="!w-200px"
        />
      </el-form-item>
      <el-form-item>
        <el-button @click="handleQuery"><Icon icon="ep:search" class="mr-5px" /> 搜索</el-button>
        <el-button @click="resetQuery"><Icon icon="ep:refresh" class="mr-5px" /> 重置</el-button>
        <el-button
          type="primary"
          plain
          @click="openBatchSetDialog"
          v-hasPermi="['hotel:price:update']"
        >
          <Icon icon="ep:setting" class="mr-5px" /> 批量设置
        </el-button>
      </el-form-item>
    </el-form>
  </ContentWrap>

  <!-- 价格列表 -->
  <ContentWrap>
    <el-table v-loading="loading" :data="list" :stripe="true" border>
      <el-table-column label="店铺" align="center" width="120">
        <template #default="scope">
          <span>{{ getShopName(scope.row.shopId) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="房型" align="center" width="120">
        <template #default="scope">
          <span>{{ getSpuName(scope.row.spuId) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="变体" align="center" width="120">
        <template #default="scope">
          <span>{{ scope.row.skuId ? getSkuName(scope.row.skuId) : '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="日期" align="center" prop="date" width="120" />
      <el-table-column label="价格" align="center" prop="price" width="140">
        <template #default="scope">
          <el-tag type="danger" effect="dark">
            {{ scope.row.price ? '¥' + scope.row.price.toFixed(2) : '-' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="加床价格" align="center" prop="extraBedPrice" width="140">
        <template #default="scope">
          <el-tag type="warning" effect="plain">
            {{ scope.row.extraBedPrice != null ? '¥' + Number(scope.row.extraBedPrice).toFixed(2) : '¥0.00' }}
          </el-tag>
        </template>
      </el-table-column>
    </el-table>
  </ContentWrap>

  <!-- 批量设置弹窗 -->
  <Dialog :title="'批量设置价格'" v-model="batchDialogVisible" width="500px">
    <el-form ref="batchFormRef" :model="batchFormData" :rules="batchFormRules" label-width="100px" v-loading="batchFormLoading">
      <el-form-item label="店铺" prop="shopId">
        <el-select
          v-model="batchFormData.shopId"
          placeholder="请选择店铺"
          clearable
          filterable
        >
          <el-option
            v-for="shop in shopList"
            :key="shop.id"
            :label="shop.name"
            :value="shop.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="房型" prop="spuId">
        <el-select
          v-model="batchFormData.spuId"
          placeholder="请选择房型"
          clearable
          filterable
        >
          <el-option
            v-for="spu in spuList"
            :key="spu.id"
            :label="spu.name"
            :value="spu.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="变体" prop="skuId">
        <el-select v-model="batchFormData.skuId" placeholder="请选择变体(可选所有)" clearable filterable>
          <el-option
            v-for="sku in skuList"
            :key="sku.id"
            :label="sku.name"
            :value="sku.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="日期范围" prop="dateRange">
        <el-date-picker
          v-model="batchFormData.dateRange"
          type="daterange"
          value-format="YYYY-MM-DD"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          class="!w-1/1"
        />
      </el-form-item>
      <el-form-item label="价格" prop="price">
        <el-input-number v-model="batchFormData.price" :min="0" :precision="2" class="!w-1/1" placeholder="请输入价格" />
      </el-form-item>
      <el-form-item label="加床价格" prop="extraBedPrice">
        <el-input-number v-model="batchFormData.extraBedPrice" :min="0" :precision="2" class="!w-1/1" placeholder="请输入加床价格" />
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button @click="submitBatchForm" type="primary" :disabled="batchFormLoading">确 定</el-button>
      <el-button @click="batchDialogVisible = false">取 消</el-button>
    </template>
  </Dialog>
</template>

<script setup lang="ts">
import * as priceApi from '@/api/hotel/price'
import { getShopSimpleList } from '@/api/hotel/platformShop'
import { getSpuSimpleList, getSpu } from '@/api/mall/product/spu'
import { watch } from 'vue'

defineOptions({ name: 'HotelPrice' })

const message = useMessage()

const loading = ref(true)
const shopList = ref<{ id: string | number; name: string }[]>([])
const spuList = ref<{ id: string | number; name: string }[]>([])

const fetchDropdownData = async () => {
  try {
    const [shopRes, spuRes] = await Promise.all([
      getShopSimpleList(),
      getSpuSimpleList()
    ])
    shopList.value = shopRes || []
    spuList.value = spuRes || []
  } catch {
    // 静默处理
  }
}

// SKU 列表（根据选中房型动态加载）
const skuList = ref<{ id: string | number; name: string }[]>([])
const loadSkuList = async (spuId: string | number | undefined) => {
  if (!spuId) {
    skuList.value = []
    return
  }
  try {
    const spu = await getSpu(spuId)
    skuList.value = (spu?.skus || []).map((s: any) => ({ id: s.id, name: s.name || '变体#' + s.id }))
  } catch {
    skuList.value = []
  }
}
const list = ref<priceApi.PriceVO[]>([])
const total = ref(0)
const shopNameMap = computed(() => {
  const map = new Map<string | number, string>()
  shopList.value.forEach((item) => map.set(item.id, item.name))
  return map
})
const spuNameMap = computed(() => {
  const map = new Map<string | number, string>()
  spuList.value.forEach((item) => map.set(item.id, item.name))
  return map
})
const getShopName = (id: string | number) => shopNameMap.value.get(id) || '-'
const getSpuName = (id: string | number) => spuNameMap.value.get(id) || '-'
const skuNameMap = computed(() => {
  const map = new Map<string | number, string>()
  skuList.value.forEach((item) => map.set(item.id, item.name))
  return map
})
const getSkuName = (id: string | number) => skuNameMap.value.get(id) || '变体#' + id
const queryParams = reactive({
  shopId: undefined,
  spuId: undefined,
  skuId: undefined,
  dateRange: [] as string[]
})
const queryFormRef = ref()

const getList = async () => {
  loading.value = true
  try {
    const params: any = {}
    if (queryParams.shopId) params.shopId = queryParams.shopId
    if (queryParams.spuId) params.spuId = queryParams.spuId
    if (queryParams.skuId) params.skuId = queryParams.skuId
    if (queryParams.dateRange && queryParams.dateRange.length === 2) {
      params.startDate = queryParams.dateRange[0]
      params.endDate = queryParams.dateRange[1]
    }
    const data = await priceApi.queryCalendar(params)
    // 后端返回 List（非分页），直接赋值
    list.value = Array.isArray(data) ? data : []
    total.value = list.value.length
  } finally {
    loading.value = false
  }
}

const handleQuery = () => {
  getList()
}

const resetQuery = () => {
  queryFormRef.value?.resetFields()
  queryParams.dateRange = []
  handleQuery()
}

// 批量设置
const batchDialogVisible = ref(false)
const batchFormLoading = ref(false)
const batchFormRef = ref()
const batchFormData = reactive({
  shopId: undefined as string | number | undefined,
  spuId: undefined as string | number | undefined,
  skuId: undefined as string | number | undefined,
  dateRange: [] as string[],
  price: 0,
  extraBedPrice: 0
})
const batchFormRules = reactive({
  shopId: [{ required: true, message: '请选择店铺', trigger: 'change' }],
  spuId: [{ required: true, message: '请选择房型', trigger: 'change' }],
  dateRange: [{ required: true, message: '请选择日期范围', trigger: 'change' }],
  price: [{ required: true, message: '请输入价格', trigger: 'blur' }],
  extraBedPrice: [{ required: true, message: '请输入加床价格', trigger: 'blur' }]
})

const openBatchSetDialog = () => {
  batchFormData.shopId = undefined
  batchFormData.spuId = undefined
  batchFormData.skuId = undefined
  batchFormData.dateRange = []
  batchFormData.price = 0
  batchFormData.extraBedPrice = 0
  batchFormRef.value?.resetFields()
  batchDialogVisible.value = true
}

const submitBatchForm = async () => {
  await batchFormRef.value.validate()
  batchFormLoading.value = true
  try {
    const [startDate, endDate] = batchFormData.dateRange
    // 展开日期范围，每条记录一个日期
    const records: priceApi.BatchSetDTO[] = []
    let cur = new Date(startDate)
    const end = new Date(endDate)
    while (cur <= end) {
      records.push({
        shopId: batchFormData.shopId!,
        spuId: batchFormData.spuId!,
        date: cur.toISOString().split('T')[0],
        price: batchFormData.price,
        extraBedPrice: batchFormData.extraBedPrice
      })
      cur = new Date(cur.getTime() + 86400000)
    }
    await priceApi.batchSet(records)
    message.success('批量设置成功')
    batchDialogVisible.value = false
    await getList()
  } finally {
    batchFormLoading.value = false
  }
}

onMounted(() => {
  fetchDropdownData()
  getList()
})

// 搜索区房型变化时加载变体列表
watch(() => queryParams.spuId, (newVal) => {
  queryParams.skuId = undefined
  loadSkuList(newVal != null ? newVal : undefined)
})

// 批量设置区房型变化时加载变体列表
watch(() => batchFormData.spuId, (newVal) => {
  batchFormData.skuId = undefined
  loadSkuList(newVal != null ? newVal : undefined)
})
</script>
